import { Dispatch } from 'redux';
import { LoginService } from "../../services/LoginService";
import { adminapi } from "../../ApiNames";

type Nullable<T> = T | null;

export const fetchdatasuccess = (data:any)=>({
    type : 'fetch_data_success',
    payload:data
})
export const fetchDataViewSuccess = (viewdata: any) => ({
    type: 'FETCH_VIEW_DATA_SUCCESS',
    payload: viewdata,
});
export const ApproveDataSuccess = (approvedata: any) => ({
    type: 'Approve_DATA_SUCCESS',
    payload: approvedata,
});
export const RejectDataSuccess = (rejectdata: any) => ({
    type: 'Reject_DATA_SUCCESS',
    payload: rejectdata,
});
export const fetchdocdata = (docdata: any) => ({
    type: 'VIEW_DATA_SUCCESS',
    payload: docdata,
});
export const fetchdata = (donorID:any)=>{
    return async (dispatch:Dispatch) =>{
        try{
            const payload = {need:donorID,q:12};
            const apiname = adminapi.ad_donordocument
            const response = await LoginService.getData(apiname,payload);
            dispatch(fetchdatasuccess(response));
        }catch(error) {
            console.error('Error fetching data:', error);
        }
    }
}
export const fetchviewdata = (donorID:any)=>{
    return async (dispatch:Dispatch) =>{
        try{
            const payload = {need:donorID,q:1};
            const apiname = adminapi.ad_donordocument
            const response = await LoginService.getData(apiname,payload);
            dispatch(fetchDataViewSuccess(response));
        }catch(error) {
            console.error('Error fetching data:', error);
        }
    }
}
export const ApproveData = ( donorID:any) => {
    return async (dispatch: Dispatch) => {
        try {
            const payload = { q: 4,need:donorID};
            const apiname = adminapi.ad_donordocument;
            const response = await LoginService.getData(apiname,payload);
            dispatch(ApproveDataSuccess(response));
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };
};
export const RejectData = ( donorID:any) => {
    return async (dispatch: Dispatch) => {
        try {
            const payload = { q: 5,need:donorID};
            const apiname = adminapi.ad_donordocument;
            const response = await LoginService.getData(apiname,payload);
            dispatch(RejectDataSuccess(response));
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };
};
export const fetchviewDoc = ( DocID:string) => {
    return async (dispatch: Dispatch) => {
        try {
            const payload = { q: 4,did:DocID};
            const apiname = adminapi.ad_docview;
            const response = await LoginService.getData(apiname,payload);
            dispatch(fetchdocdata(response));
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };
};